// Terms of Service Page
export function TermsOfServicePage() {
  return `
<div class="min-h-screen bg-gray-50">
    <div class="hero">
        <div class="hero-content">
            <h1 class="hero-title">Términos del Servicio</h1>
            <p class="hero-subtitle">Condiciones generales para el uso de nuestros servicios</p>
        </div>
    </div>

    <section class="section bg-gray-50">
        <div class="container">
            <div class="max-w-4xl mx-auto prose prose-lg">
                <div class="bg-white p-8 rounded-lg shadow-sm">
                    <h2 class="text-2xl font-bold text-gray-900 mb-6">Términos del Servicio</h2>
                    
                    <div class="space-y-6 text-gray-700">
                        <h2 class="text-2xl font-bold text-gray-900 mb-6">Condiciones Generales – Clientes (España)</h2>
                        
                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Artículo 1 – Definiciones</h3>
                        <ul class="space-y-3">
                            <li><strong>Oferta:</strong> el conjunto de productos y servicios del Asesor (Certificado de Eficiencia Energética) que el Cliente puede contratar a través de la Plataforma.</li>
                            <li><strong>Mediación / Servicio:</strong> los servicios de intermediación comercial prestados por Epcspainhomes España S.L. para facilitar la celebración de un contrato entre Cliente y Asesor.</li>
                            <li><strong>Plataforma:</strong> el sitio web, herramientas y otros canales digitales de Epcspainhomes España S.L. donde se ofrece el Servicio.</li>
                            <li><strong>Asesor:</strong> técnico o empresa reconocida en España y autorizada para elaborar y registrar un Certificado de Eficiencia Energética ante la autoridad competente de la comunidad autónoma.</li>
                            <li><strong>Cliente:</strong> toda persona física o jurídica que realiza un Encargo a través de la Plataforma.</li>
                            <li><strong>Certificado de Eficiencia Energética (CEE):</strong> el certificado oficial que indica el rendimiento energético de un inmueble, obligatorio en ventas o alquileres según el Real Decreto 390/2021.</li>
                            <li><strong>Contrato / Encargo:</strong> el acuerdo entre el Cliente y el Asesor para la elaboración del CEE.</li>
                            <li><strong>CeeCasasEspana España S.L.:</strong> la entidad intermediaria que presta el Servicio, con sede en España y operando bajo el nombre CeeCasasEspaña.com.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Artículo 2 – Identidad de CeeCasasEspaña.com</h3>
                        <p>Epcspainhomes España S.L.<br>
                        Domicilio: Av. de Andalucia, 21, 29679 Benahavís, Málaga<br>
                        Inscrita en el Registro Mercantil de Madrid con número [indicar].<br>
                        CIF: [indicar].<br>
                        E-mail: info@ceecasasespana.com</p>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Artículo 3 – Aplicabilidad</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>Estas Condiciones Generales se aplican al Servicio prestado por CeeCasasEspaña.com.</li>
                            <li>CeeCasasEspaña.com no es responsable del contenido de la Oferta ni de la ejecución del Encargo, que corresponde única y exclusivamente al Asesor.</li>
                            <li>Al realizar un Encargo a través de la Plataforma, el Cliente celebra un contrato directamente con el Asesor.</li>
                            <li>La cancelación del Encargo puede realizarse en un plazo de 14 días naturales según la Ley General para la Defensa de los Consumidores y Usuarios (Real Decreto Legislativo 1/2007), salvo que el servicio ya se haya prestado.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Artículo 4 – Oferta</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>CeeCasasEspaña.com publica la Oferta en nombre de los Asesores basándose en la información facilitada por ellos.</li>
                            <li>Aunque la información se elabora con la máxima diligencia, CeeCasasEspaña.com no se hace responsable de errores o inexactitudes en la Oferta o en los datos del Asesor.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Artículo 5 – Celebración del Contrato</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>El Contrato se perfecciona cuando el Cliente confirma el Encargo a través de la Plataforma.</li>
                            <li>El Cliente es responsable de proporcionar datos correctos y completos para la elaboración del CEE.</li>
                            <li>El pago se realiza a través de la Plataforma o directamente al Asesor. CeeCasasEspaña.com podrá estar autorizada por el Asesor para gestionar pagos.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Artículo 6 – Cancelación y resolución</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>El Cliente puede cancelar el Encargo dentro de los 14 días posteriores a su confirmación, salvo que el servicio ya haya sido realizado.</li>
                            <li>Si el Asesor no puede ejecutar el Encargo por causa de fuerza mayor o datos incorrectos, el Contrato podrá resolverse sin derecho a indemnización.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Artículo 7 – Pago</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>Todos los precios están expresados en euros e incluyen IVA.</li>
                            <li>El pago se realiza por adelantado mediante un método de pago seguro.</li>
                            <li>La factura será emitida por el Asesor o en su nombre por CeeCasasEspaña.com.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Artículo 8 – Reclamaciones</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>Las reclamaciones sobre la ejecución del Encargo deben dirigirse directamente al Asesor.</li>
                            <li>Las reclamaciones sobre el Servicio de CeeCasasEspaña.com pueden enviarse por correo electrónico a info@ceecasasespana.com.</li>
                            <li>CeeCasasEspaña.com confirmará la recepción en un plazo de 7 días y procurará responder en un máximo de 14 días.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Artículo 9 – Boletín y valoraciones</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>El Cliente puede inscribirse voluntariamente al boletín y darse de baja en cualquier momento.</li>
                            <li>Tras finalizar el Encargo, el Cliente puede dejar una valoración que será visible en la Plataforma.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Artículo 10 – Protección de datos</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>Los datos personales se tratarán conforme al Reglamento (UE) 2016/679 (GDPR) y la Ley Orgánica 3/2018 (LOPDGDD).</li>
                            <li>La política de privacidad está disponible en www.ceecasasespana.com.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Artículo 11 – Propiedad intelectual</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>Todos los textos, diseños, logotipos y demás contenidos del Plataforma son propiedad de CeeCasasEspaña.com.</li>
                            <li>Está prohibido copiar, modificar o publicar cualquier contenido sin autorización escrita previa.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Artículo 12 – Ley aplicable y jurisdicción</h3>
                        <ul class="list-disc pl-6 space-y-2">
                            <li>Las presentes Condiciones Generales se rigen exclusivamente por la legislación española.</li>
                            <li>Cualquier disputa será sometida a los tribunales competentes de Madrid, salvo disposición legal en contrario.</li>
                        </ul>

                        <h3 class="text-xl font-semibold text-gray-900 mt-8 mb-4">Contacto</h3>
                        <p>Para preguntas relacionadas con estos términos del servicio:</p>
                        <p><strong>E-mail:</strong> info@ceecasasespana.com</p>
                        <p><strong>Teléfono:</strong> 626 80 65 52</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

    `;
}
